import { Skeleton } from "@mui/material";

export function LocationSkeleton({ label }: { label: string }) {
  return (
    <div className="flex flex-col gap-1">
      <p className="text-md text-black">{label}</p>
      <Skeleton variant="rectangular" height={40} />
    </div>
  );
}